export const CHART_ACCENT = '#3987e5';
export const CHART_GRID = '#23232a';
export const CHART_AXIS_TEXT = '#686868';
export const CHART_TOOLTIP_BG = '#0a0a0a';
export const CHART_TOOLTIP_BORDER = '#23232a';

export const axisTickStyle = { fill: CHART_AXIS_TEXT, fontSize: 12 };

export const tooltipContentStyle = {
  background: CHART_TOOLTIP_BG,
  border: `1px solid ${CHART_TOOLTIP_BORDER}`,
  borderRadius: 8,
  color: '#fff',
  fontSize: 13,
};

export const tooltipLabelStyle = { color: '#686868', marginBottom: 4 };
